<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Key Dates History</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div *ngIf="!keyDates || keyDates?.length == 0" class="alert alert-info">
    No Key Dates History
  </div>

  <div *ngIf="keyDates?.length > 0" class="table-responsive" style="max-height: 70vh; overflow-y: auto;">
    <table mat-table [dataSource]="keyDates" class="small">

      <ng-container matColumnDef="keyDateType">
        <mat-header-cell *matHeaderCellDef style="min-width: 30%">Key Date.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate" style="min-width: 30%">{{keyDate.keyDateTypeName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="value">
        <mat-header-cell *matHeaderCellDef>Value.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate">{{formatDateOnly(keyDate.value)}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="enteredByUser">
        <mat-header-cell *matHeaderCellDef>Added By.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate">
          <span *ngIf="keyDate.enteredByUser">{{keyDate.enteredByUser.firstName}} {{keyDate.enteredByUser.lastName}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="enteredOn">
        <mat-header-cell *matHeaderCellDef>Date Added.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate">{{formatDateWithTime(keyDate.enteredOn)}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="removedByUser">
        <mat-header-cell *matHeaderCellDef>Removed By.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate">
          <span *ngIf="keyDate.removedByUser">{{keyDate.removedByUser.firstName}} {{keyDate.removedByUser.lastName}}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="removedDate">
        <mat-header-cell *matHeaderCellDef>Removed Date.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate">{{formatDateWithTime(keyDate.removedDate)}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="removalReason">
        <mat-header-cell *matHeaderCellDef>Reason.</mat-header-cell>
        <mat-cell *matCellDef="let keyDate">{{keyDate.removalReason}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
      <mat-row *matRowDef="let keyDate; columns: displayedColumns;"></mat-row>

    </table>
  </div>

</div>